<template>
	<section id="tema">
		<!--<iframe width="100%" :height="windowHeight - 7"
			src="http://ftp.novatech.net.br/repositorio/arquitetura_cisc_x__risc/index.html"
			@load="cadastrado">
		</iframe>-->
		<iframe id="iframeContent" ref="iframeContent" width="100%" :height="windowHeight - 7"
			:src="url">
		</iframe>
	</section>
</template>

<script>
import { integracao } from '@/services/integracoes'
export default {
	name: 'ClienteList',
	data () {
		return {
			windowHeight: 0,
			// url: 'http://ftp.novatech.net.br/repositorio/_TEMPLATE_BASE_NOVA_TECH/index.html',
			url: '',
			matricula: '',
			nomeAluno: '',
			temaId: {}
		}
	},
	async created () {
		const temaId = this.$route.query.temaId
		this.temaId = temaId

		const windowHeight = window.innerHeight
		this.windowHeight = windowHeight

		try {
			const tema = await integracao.obterUrl({ temaId })
			this.url = tema.data.body.urlArquivo
			this.matricula = tema.data.body.matricula
			this.nomeAluno = tema.data.body.nomeAluno
			this.loadTema()
		} catch (err) {
			this.$router.push('/login')
		}
	},
	methods: {
		loadTema () {
			this.frame = this.$refs.iframeContent.contentWindow
			const conteudo = {
				studentName: this.nomeAluno,
				studentNumber: this.matricula,
				origin: 'player',
				clientId: 'D772E53F-A2BD-D21E-3402-2208D12BAE49',
				themeId: this.temaId
			}

			const readyAction = function (evt) {
				if (typeof evt.data.waiting !== 'undefined' && evt.data.waiting === 'true') {
					document.getElementById('iframeContent').contentWindow.postMessage(conteudo, '*')
					window.removeEventListener('message', readyAction)
				}
			}
			window.addEventListener('message', readyAction)
		}
	}
}
</script>

<style lang="scss">
body {
	background-color: #fff !important;
	background-image: none !important;
}
</style>
